import React, { Component } from 'react';
import PropTypes from 'prop-types';

require('./AddressCard.scss');

class AddressCard extends Component {
  addressUnvailableMsg = () => {
    if (!this.props.isDiagnosticsAddress) {
      return null;
    }
    const { pincodeDetails: { is_serviceable, is_pathlab_enabled } } = this.props;
    let message = null;
    // eslint-disable-next-line camelcase
    if (!is_pathlab_enabled) {
      message = (<div className="errorMessage">
        <svg width={16} className="icon" height={16} xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16">
          <path
            fill="currentColor"
            fillRule="nonzero"
            d="M.75 15c-.557 0-.92-.55-.67-1.018L7.33.39c.276-.519 1.064-.519 1.34 0l7.25 13.593c.25.468-.113 1.018-.67 1.018H.75zm6.5-9.375v4.688h1.5V5.625h-1.5zM8 12.656c.414 0 .75-.315.75-.703 0-.388-.336-.703-.75-.703s-.75.315-.75.703c0 .388.336.703.75.703z"
          />
        </svg>
        <span className="text">
          Diagnostics services are currently unavailable at this pincode.
        </span>
      </div>);
    // eslint-disable-next-line camelcase
    } else if (!is_serviceable) {
      message = (<div className="errorMessage">
        <svg width={16} className="icon" height={16} xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16">
          <path
            fill="currentColor"
            fillRule="nonzero"
            d="M.75 15c-.557 0-.92-.55-.67-1.018L7.33.39c.276-.519 1.064-.519 1.34 0l7.25 13.593c.25.468-.113 1.018-.67 1.018H.75zm6.5-9.375v4.688h1.5V5.625h-1.5zM8 12.656c.414 0 .75-.315.75-.703 0-.388-.336-.703-.75-.703s-.75.315-.75.703c0 .388.336.703.75.703z"
          />
        </svg>
        <span className="text">
          Selected lab is unavailable at this pincode.
          Please delete items from your cart, change the pincode and select items again.
        </span>
      </div>);
    }
    return message;
  }
  selectAddress = addressDetails => {
    const { pincodeDetails } = this.props;
    if (addressDetails.isDeliverable === 0) {
      return;
    }

    if (this.props.isDiagnosticsAddress && (!pincodeDetails.is_serviceable || !pincodeDetails.is_pathlab_enabled)) {
      return;
    }
    this.props.selectAddress(addressDetails);
  }
  render() {
    const { addressDetails, deleteAddress, editAddressClicked, selectedAddressId } = this.props;
    const isUndeliverable = addressDetails.isDeliverable === 0;

    return (
      <div className={`addressCardContainer ${isUndeliverable ? 'undeliverable' : ''}`}>
        <div className="addressDetailsContainer">
          <div className="addressDetailsHeader" onClick={() => this.selectAddress(addressDetails)}>
            <span className="addressDetailsName">{addressDetails.contactName}</span>
            <span className="addressDetailsType">{addressDetails.typeDescription}</span>
          </div>
          <div className="addressDetailsGen" onClick={() => this.selectAddress(addressDetails)}>
            {addressDetails.flatNumber}
          </div>
          <div className="addressDetailsGen" onClick={() => this.selectAddress(addressDetails)}>
            {addressDetails.streetName}
          </div>
          <div className="addressDetailsGen" onClick={() => this.selectAddress(addressDetails)}>
            <span>{addressDetails.cityName}</span>
            <span>-{addressDetails.pincode}</span>
          </div>
          <div className="addressDetailsGen" onClick={() => this.selectAddress(addressDetails)}>
            {addressDetails.contactNumber}
          </div>
          {!isUndeliverable && (<div className="btnContainer">
            <span className="btnTextEdit" onClick={() => editAddressClicked(addressDetails)}>Edit</span>
            <span className="btnTextDelete" onClick={() => deleteAddress(addressDetails.id)}>Delete</span>
          </div>)}
          {this.addressUnvailableMsg()}
          {isUndeliverable && <div className="undeliverableText">Undeliverable Address</div>}
        </div>
        {!isUndeliverable && (<div className="addressDetailsSelect">
          <input
            checked={selectedAddressId === addressDetails.id ? true : ''}
            type="radio" name="address"
            value={addressDetails.id}
            onClick={() => this.selectAddress(addressDetails)}
          />
        </div>)}
      </div>
    );
  }
}

AddressCard.propTypes = {
  addressDetails: PropTypes.object.isRequired,
  pincodeDetails: PropTypes.object,
  deleteAddress: PropTypes.func.isRequired,
  editAddressClicked: PropTypes.func.isRequired,
  selectAddress: PropTypes.func.isRequired,
  isDiagnosticsAddress: PropTypes.bool,
  selectedAddressId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

AddressCard.defaultProps = {
  pincodeDetails: {},
  isDiagnosticsAddress: false
};
export default AddressCard;
